import * as Joi from 'joi';
import { AdminProfileIsDisableInputs } from '../../../models';
import {
  getEmailSchema,
  getJoiObject,
  getMasterCodeObjectDropdownSchema,
  getNricFinJoiObject,
  getPhoneNumberSchema,
  validateSingaporeCountry,
} from '../../../utils/JoiUtils';

const countryCodeKey = 'country code';
const adminSchema = (isDisableInputs?: AdminProfileIsDisableInputs) =>
  Joi.object({
    adminId: getJoiObject(
      Joi.string().required().messages({
        'string.base': 'Name is not allowed to be empty',
      }),
      isDisableInputs?.adminId
    ),
    statutoryName: getJoiObject(
      Joi.string().required().max(66).messages({
        'string.empty': 'Name is not allowed to be empty',
        'string.max': 'Name is too long',
      }),
      isDisableInputs?.statutoryName
    ),
    accountType: getJoiObject(Joi.string().required(), isDisableInputs?.accountType),
    userIdType: getJoiObject(Joi.string().required(), isDisableInputs?.userIdType),
    NricFin: getNricFinJoiObject(isDisableInputs?.adminId),
    dateOfBirth: getJoiObject(
      Joi.string().required().messages({
        'any.required': 'Date of birth is not allowed to be empty',
      }),
      isDisableInputs?.dateOfBirth
    ),
    email: getJoiObject(getEmailSchema('Email'), isDisableInputs?.email),
    mobileCountryCode: getJoiObject(
      getMasterCodeObjectDropdownSchema(false, countryCodeKey),
      isDisableInputs?.mobileCountryCode
    ),
    mobileContactNumber: getJoiObject(
      Joi.when('mobileCountryCode', {
        is: validateSingaporeCountry,
        then: getPhoneNumberSchema(false, 'Mobile No.', 8, 8),
        otherwise: getPhoneNumberSchema(false, 'Mobile No.'),
      }),
      isDisableInputs?.mobileContactNumber
    ),
    photoUUid: getJoiObject(
        Joi.any().optional(),
        isDisableInputs?.photoUUid
    ),
    photoUrl: getJoiObject(
        Joi.any().optional(),
        isDisableInputs?.photoUrl
    ),
  });

export default adminSchema;
